import { AppPaths, Challenge } from "@/shared/common/enums";

export const ChallengeUrls = {
  [Challenge.Authentication]: AppPaths.Login,
  [Challenge.TwoFactorAuthentication]: AppPaths.Two_Factor,
  [Challenge.PasswordReset]: AppPaths.New_Password,
  [Challenge.SmsVerificationRequired]: AppPaths.Otp_Verification,
};
